// Utilidad para peticiones API con manejo de cookies
export const apiRequest = async (url, options = {}) => {
  const defaultOptions = {
    credentials: "include", // El token viaja en la cookie HttpOnly
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  };

  const finalOptions = {
    ...defaultOptions,
    ...options,
    credentials: "include",
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, finalOptions);

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const errorData = await response.json();
      const error = new Error(
        errorData.error ||
          errorData.message ||
          `Error ${response.status}: ${response.statusText}`,
      );

      if (errorData && typeof errorData === "object") {
        Object.assign(error, errorData, { status: response.status });
      } else {
        error.status = response.status;
      }

      throw error;
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Error en petición API:", error);
    }
    throw error;
  }
};

export const loginRequest = async (credentials) => {
  const { buildApiUrl, API_ENDPOINTS } = await import("../config/api");
  return apiRequest(buildApiUrl(API_ENDPOINTS.login), {
    method: "POST",
    body: JSON.stringify(credentials),
  });
};
